import { render, staticRenderFns } from "./AssetFileDownload.vue?vue&type=template&id=5331d217&scoped=true"
import script from "./AssetFileDownload.vue?vue&type=script&lang=js"
export * from "./AssetFileDownload.vue?vue&type=script&lang=js"
import style0 from "./AssetFileDownload.vue?vue&type=style&index=0&id=5331d217&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5331d217",
  null
  
)

export default component.exports